import { render, staticRenderFns } from "./coAccount.vue?vue&type=template&id=cb062560&scoped=true&"
import script from "./coAccount.vue?vue&type=script&lang=js&"
export * from "./coAccount.vue?vue&type=script&lang=js&"
import style0 from "./coAccount.vue?vue&type=style&index=0&id=cb062560&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb062560",
  null
  
)

export default component.exports